import { InteractionRow } from "namirasoft-inference";
import { NSButton } from "namirasoft-site-react";
import { Component } from "react";
import Interaction from "./Interaction";
import Styles from "./InteractionGroup.module.css";

interface InteractionGroupProps
{
    interactions: InteractionRow[];
    defaultIndex: number;
}

interface InteractionGroupState
{
    index: number;
}

class InteractionGroup extends Component<InteractionGroupProps, InteractionGroupState>
{
    constructor(props: InteractionGroupProps)
    {
        super(props);
        this.state = { index: props.defaultIndex };
    }

    private go(delta: number)
    {
        let total = this.props.interactions.length;
        let next = (this.state.index + delta + total) % total;
        this.setState({ index: next });
    }

    override render()
    {
        let total = this.props.interactions.length;
        let current = this.props.interactions[this.state.index];
        let others = total - 1;
        let isWinner = current.winner;
        let hasAnyWinner = this.props.interactions.some(r => r.winner);
        let showBadge = total > 1 && hasAnyWinner;
        let pager = total > 1 ?
            <div className={Styles.ns_group_pager}>
                {
                    showBadge &&
                    <span className={isWinner ? Styles.ns_group_badge_winner : Styles.ns_group_badge_loser}>
                        {isWinner ? "Winner" : "Loser"}
                    </span>
                }
                <span className={Styles.ns_group_label}>
                    {others} other{others === 1 ? "" : "s"}
                </span>
                <NSButton
                    onClick={{ showLoading: false, action: () => this.go(-1) }}
                    classList={[Styles.ns_group_btn]}
                    title="‹"
                    attributes={{ "aria-label": "Previous" }}
                />
                <span className={Styles.ns_group_index}>
                    {this.state.index + 1} / {total}
                </span>
                <NSButton
                    onClick={{ showLoading: false, action: () => this.go(1) }}
                    classList={[Styles.ns_group_btn]}
                    title="›"
                    attributes={{ "aria-label": "Next" }}
                />
            </div>
            : null;
        return <Interaction interaction={current} headerExtra={pager} />;
    }
}

export default InteractionGroup;